module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-thanksgiving-right-adac8f37c0e4051fed28eab41869340f.svg";